import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import {
  IIncludedItems,
  IIncludedItemsList,
} from 'src/shared/models/includedItems.model';

const { INCLUDED_ITEMS_LIST_DESCRIPTION, INCLUDED_ITEM_ICON } =
  ResourceTypeDetailEnum;

const getIncludedItem = ({
  name,
  idResource,
  resourceDetailList,
}: IResourceList): IIncludedItems => {
  let item = { title: name, idResource } as IIncludedItems;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case INCLUDED_ITEM_ICON:
          item = {
            ...item,
            icon: value,
          };
          break;
      }
    });
  return { ...item };
};

export const buildChallengeIncludedItemsList = (
  resource: IResourceList
): IIncludedItemsList => {
  const { idResource, resourceList, name, resourceDetailList } = resource;

  let list = { title: name, idResource } as IIncludedItemsList;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case INCLUDED_ITEMS_LIST_DESCRIPTION:
          list = {
            ...list,
            description: value,
          };
          break;
      }
    });

  const items: IIncludedItems[] =
    resourceList?.map((resource) => getIncludedItem(resource)) || [];

  return { ...list, items };
};
